import { alertActions } from './AlertsActions'
import { waterMeterLocalize } from '../../constants'
import { axiosPrivate } from '../../../axios'
import { meterType } from '../../../../../server/common/constants/Meters.constants'

export const DELETE_WATER_METER_INIT = 'DELETE_WATER_METER_INIT'
export const DELETE_WATER_METER_REQUEST = 'DELETE_WATER_METER_REQUEST'
export const DELETE_WATER_METER_SUCCESS = 'DELETE_WATER_METER_SUCCESS'
export const DELETE_WATER_METER_ERROR = 'DELETE_WATER_METER_ERROR'

//TODO rename all to sensor instead of water_meter
export const deleteSensor =
	({ id, dev_eui, sensorType }) =>
	(dispatch) => {
		dispatch({
			type: DELETE_WATER_METER_REQUEST,
			payload: {
				id,
				dev_eui
			}
		})
		axiosPrivate
			.post(`/${sensorType?.toLowerCase() ?? meterType.WATER_METER.toLowerCase()}/action/delete`, {
				id,
				dev_eui
			})
			.then((res) => {
				dispatch({
					type: DELETE_WATER_METER_SUCCESS,
					payload: {
						data: res.data
					}
				})
				dispatch(alertActions.successEnqueueSnackbar(waterMeterLocalize.deleteSuccess(dev_eui)))
			})
			.catch((error) => {
				dispatch({
					type: DELETE_WATER_METER_ERROR,
					payload: {
						error
					}
				})
				dispatch(alertActions.errorEnqueueSnackbar(error?.message || waterMeterLocalize.deleteError(dev_eui)))
			})
	}

export const initDeleteWaterMeter = () => (dispatch) => {
	dispatch({ type: DELETE_WATER_METER_INIT })
}
